<div class="modal-header border-0">
  <h6 class="modal-title fw-semibold text-center">รายละเอียดประวัติการลงทะเบียนสิทธิ UC</h6>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body border-0">
  <div class="row">
    <label class="col text-primary fw-semibold fs-6">Check List ตรวจสอบเงื่อนไขอัตโนมัติโดยระบบ</label>
  </div>
  <app-point-checklist-table [checklist]="checklist"></app-point-checklist-table>
</div>
<!--<div class="modal-footer">-->
  <!--  <button type="button" class="btn btn-danger" (click)="activeModal.close('Close click')">ปิด</button>-->
<!--</div>-->
